<template>
    <div class="layers">
        <div class="row">
            <div class="switch-off-row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="switch_off_times" class="checkbox-inline m-t-sm font-bold">
                            <input aria-label="switch off times" id="switch_off_times" type="checkbox"
                                   name="switch_off_times"
                                   :disabled="!layer0active || layer_count <= 1"
                                   @click="change_switch_off_times()"
                                   :checked="switch_off_times">
                            <input aria-label="switch off times" v-if="!layer0active"
                                   type="hidden"
                                   name="switch_off_times"
                                   :value="switch_off_times ? '1' : ''">
                            {{ t_switch_off_times }}
                        </label>
                    </div>
                </div>
                <div v-if="switch_off_times" class="col-md-8">
                    <div class="alert alert-warning text-center font-bold">
                        {{ t_switch_off_times_active }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-for="(element, key) in form">
            <div class="col-md-1">
                <div>{{ t_nr }}</div>
                <div class="form-group">
                    <input aria-label="number" type="text"
                           :name="'layer_data.field_'+element['id']+'.nr'"
                           class="form-control"
                           v-model="element['nr']"
                           disabled="disabled">
                </div>
            </div>
            <div v-if="switch_off_times && element['nr'] === 0" class="col-md-1">
                <div style="opacity: 0">Time</div>
                <div class="form-group">
                    <i class="fa-regular fa-clock fa-2x"></i>
                </div>
            </div>
            <div v-else :class="[full_rights === '1' ? 'active-col' : '', 'col-md-1']">
                <div>{{ element['active'] ? t_active : t_inactive }}</div>
                <div class="form-group">
                    <i :class="['fa-regular', element['active'] ? 'fa-clapperboard-play' : 'fa-ban', element['nr'] === switch_off_times_layer_primary && switch_off_times ? 'text-info' : '',
                        element['nr'] === switch_off_times_layer_secondary && switch_off_times ? 'text-navy' : '',
                        'fa-2x m-t-xs']" @click="aboutToChangeLayerActive(key, !element['active'])"></i>
                </div>
            </div>
            <div class="col-md-2">
                <div>{{ t_name }}</div>
                <div class="form-group">
                    <input aria-label="name" type="text"
                           :name="'layer_data.field_'+element['id']+'.name'"
                           class="form-control"
                           v-model="element['name']"
                           :disabled="(switch_off_times && element['nr'] === 0) || !element['active'] || full_rights === '0'">
                </div>
            </div>
            <template v-if="switch_off_times && element['nr'] === 0">
                <div class="col-md-4">
                    <div class="form-group">
                        {{ t_switch_off_times_layer_primary }}
                        <span :data-balloon="t_switch_off_times_description"
                              data-balloon-pos="down"
                              data-balloon-length="large">
                            <i class="fa-light fa-circle-question cursor-pointer"></i>
                        </span>
                        <select aria-label="primary content layer" class="form-control" name="switch_off_times_layer_primary"
                                v-model="switch_off_times_layer_primary">
                            <template v-for="element in form">
                                <option v-if="element['nr'] !== 0 && element['nr'] !== switch_off_times_layer_secondary"
                                        :value="element['nr']">{{ element['name'] }}</option>
                            </template>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        {{ t_switch_off_times_layer_secondary }}
                        <span :data-balloon="t_switch_off_times_description"
                              data-balloon-pos="down"
                              data-balloon-length="large">
                            <i class="fa-light fa-circle-question cursor-pointer"></i>
                        </span>
                        <select aria-label="secondary layer" class="form-control" name="switch_off_times_layer_secondary"
                                v-model="switch_off_times_layer_secondary">
                            <option :value="null">{{ "-- " + t_no_layer + " --"}}</option>
                            <template v-for="element in form">
                                <option v-if="element['nr'] !== 0 && element['nr'] !== switch_off_times_layer_primary"
                                        :value="element['nr']">{{ element['name'] }}</option>
                            </template>
                        </select>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="col-md-1">
                    <div>{{ t_width }}</div>
                    <div class="form-group">
                        <input aria-label="width" type="text"
                               :name="'layer_data.field_'+element['id']+'.width'"
                               class="form-control"
                               v-model="element['width']"
                               :disabled="(switch_off_times && element['nr'] === 0) || !element['active'] || full_rights === '0'">
                    </div>
                </div>
                <div class="col-md-1">
                    <div>{{ t_height }}</div>
                    <div class="form-group">
                        <input aria-label="height" type="text"
                               :name="'layer_data.field_'+element['id']+'.height'"
                               class="form-control"
                               v-model="element['height']"
                               :disabled="(switch_off_times && element['nr'] === 0) || !element['active'] || full_rights === '0'">
                    </div>
                </div>
                <div class="col-md-2">
                    {{ t_loop_settings }}
                    <div class="form-group">
                        <select aria-label="loop" class="form-control"
                                :name="'layer_data.field_'+element['id']+'.smart_loop'"
                                v-model="element['smart_loop']"
                                :disabled="(switch_off_times && element['nr'] === 0) || !element['active'] || full_rights === '0'">
                            <option value="0">{{ t_loop_whole_list }}</option>
                            <option value="1">{{ t_loop_event_wise }}</option>
                            <option value="2">{{ t_loop_restart }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-2">
                    {{ t_synchronize_playback }}
                    <span :data-balloon="t_synchronize_playback_description"
                          data-balloon-pos="left"
                          data-balloon-length="medium">
                        <i class="fa-light fa-circle-question cursor-pointer"></i>
                    </span>
                    <div class="form-group">
                        <select aria-label="sync" class="form-control"
                                :name="'layer_data.field_'+element['id']+'.synchronize_playback'"
                                v-model="element['synchronize_playback']"
                                :disabled="(switch_off_times && element['nr'] === 0) || !element['active'] || full_rights === '0'">
                            <option value="1">{{ t_yes }}</option>
                            <option value="0">{{ t_no }}</option>
                        </select>
                    </div>
                </div>
                <div v-if="use_calendar" class="col-md-2">
                    {{ t_calendar }}
                    <span :data-balloon="t_calendar_description"
                          data-balloon-pos="left"
                          data-balloon-length="medium">
                        <i class="fa-light fa-circle-question cursor-pointer"></i>
                    </span>
                    <div class="form-group">
                        <select aria-label="sync" class="form-control"
                                :name="'layer_data.field_'+element['id']+'.is_calendar'"
                                v-model="element['is_calendar']"
                                :disabled="(switch_off_times && element['nr'] === 0) || !element['active'] || full_rights === '0' || !canSwitch(element)">
                            <option :value="true">{{ t_yes }}</option>
                            <option :value="false">{{ t_no }}</option>
                        </select>
                    </div>
                </div>
            </template>
            <div class="row pl-8 font-italic" v-if="isApiLayer(element)">
                {{ t_api_layer_hint }}
            </div>
        </div>
        <input aria-label="layer data" type="hidden" :value="form_parsed" name="layer_data">
    </div>
</template>

<script>
    export default {
        props: ['light_rights', 'full_rights'],
        data: function () {
            return {
                t_nr: Lang.langGet("No."),
                t_name: Lang.langGet("Name"),
                t_active: Lang.langGet("Active"),
                t_inactive: Lang.langGet("Locked"),
                t_width: Lang.langGet("Width"),
                t_height: Lang.langGet("Height"),
                t_switch_off_times_active: Lang.langGet("Layer 0 is currently being used for Switch-On Times!"),
                t_switch_off_times_description: Lang.langGet("Here you enter the layer which you want to use as \"Main Layer\" for content. Layer 0 is used for Switch-On Times and therefore isn't available. Currently there are 64 layers available."),
                t_switch_off_times: Lang.langGet("Use Switch-On Times"),
                t_switch_off_times_layer_primary: Lang.langGet("Primary Content Layer"),
                t_switch_off_times_layer_secondary: Lang.langGet("Secondary Content Layer"),
                t_no_layer: Lang.langGet("No Layer"),
                t_yes: Lang.langGet("Yes"),
                t_no: Lang.langGet("No"),
                t_loop_settings: Lang.langGet("Loop-Settings"),
                t_loop_whole_list: Lang.langGet("Play whole list at once"),
                t_loop_event_wise: Lang.langGet("Play one event at a time"),
                t_loop_restart: Lang.langGet("Restart with first event if interrupted"),
                t_synchronize_playback: Lang.langGet("Sync settings"),
                t_synchronize_playback_description: Lang.langGet("Check system requirements in hardware.ini."),
                t_calendar: Lang.langGet('Calendar Layer'),
                t_calendar_description: Lang.langGet('Enable the calendar view for this layer. (Only empty layers can be turned into calendar view)'),
                t_api_layer_hint: Lang.langGet('This layer is selected as API layer.'),

                form: {},
                switch_off_times: false,
                switch_off_times_layer_primary: 1,
                switch_off_times_layer_secondary: null,
                use_calendar: false,

                something_critical_changed: false,
            }
        },
        computed: {
            form_parsed: function () {
                return JSON.stringify(this.form);
            },
            layer0active: function () {
                const firstLayer = _.values(this.form).filter(element => {
                    return element.nr === 0;
                });
                if(firstLayer.length <= 0) {
                    return null;
                }
                return firstLayer[0].active
            },
            layer_count: function () {
                return Object.keys(this.form).length;
            }
        },
        watch: {
            layer0active: function(val) {
                if(val === false) {
                    this.switch_off_times = false;
                }
            },
        },
        methods: {
            change_switch_off_times: function () {
                this.switch_off_times = !this.switch_off_times;
                if(this.switch_off_times) {
                    if(!confirm(Lang.langChoice("Are you sure, you want to activate Switch-On Times? Content could be overwritten.|", this.switch_off_times ? 1 : 2))) {
                        this.$nextTick(() => {
                            this.switch_off_times = false;
                        });
                    } else {
                        this.something_critical_changed = true;
                    }
                }
            },
            reset: function () {
                _.extend(this.$data, this.$options.data());
            },
            aboutToChangeLayerActive: function(index, new_val) {
                if(this.full_rights === '1') {
                    if(confirm(Lang.langChoice("Are you sure, you want to activate the layer? Content could be overwritten.|Are you sure, that you want to deactivate the layer? Content on this layer can no longer be edited.", new_val ? 1 : 2))) {
                        this.form[index].active = new_val;
                        this.something_critical_changed = true;
                    }
                }
            },
            canSwitch(element) {
                if (this.isApiLayer(element)) return false;
                if (element['is_calendar']) return true;

                return element['element_count'] === 0;
            },
            isApiLayer(element) {
                return element['is_api_layer'];
            }
        },
        mounted() {
            EaseEventBus.listen('buildLayers', (data) => {
                this.reset();
                const form = {};

                const apiLayerNr = data.api_layer_id; // this is actually the nr not the id

                data.fields.forEach((field) => {
                    const key = 'field_' + field.id;
                    form[key] = field;
                    if (apiLayerNr === field.nr) {
                        form[key].is_api_layer = true;
                    }
                });

                this.form = _.extend({}, this.form, form);
                this.switch_off_times = data.switch_off_times == true;
                this.switch_off_times_layer_primary = data.switch_off_times_layer_primary ? data.switch_off_times_layer_primary : 1;
                this.switch_off_times_layer_secondary = data.switch_off_times_layer_secondary;
                this.use_calendar = data.calendar == true;
            });

            $(document).on('confirmSavingProject', (event) => {
                let isConfirmed = true;

                if(this.something_critical_changed) {
                    isConfirmed = confirm(Lang.langGet("You are about to save the project settings, after changing some critical settings. Do you want to continue?"));
                }
                $(document).trigger('savingProjectConfirmed', [isConfirmed]);
            });
        }
    }
</script>
